// extracted by mini-css-extract-plugin
module.exports = {"oddsBoostHeader":"_ce11474","oddsBoostTitle":"_330bfd4","oddsBoostTitleText":"_87d46f0"};